import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var LoaderCircle = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/React.createElement(StyledIconBase, _extends({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 20,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 4,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.343,
    cy: 17.657,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.657,
    cy: 6.343,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 12,
    r: 2.001
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 12,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.343,
    cy: 6.344,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.657,
    cy: 17.658,
    r: 2
  }));
});
LoaderCircle.displayName = 'LoaderCircle';
export var LoaderCircleDimensions = {
  height: 24,
  width: 24
};